import { type AxiosResponse } from "axios"
import { BaseRepository } from "@/repositories/base-repository"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { IPushToken } from "@/interfaces/api/push-token.interface"

export class PushTokenRepository extends BaseRepository<IPushToken> {
  protected resourcePath = "auth/add-token"

  // noinspection JSAnnotator
  public async post(/* Note absence of id param */ item: IPushToken): Promise<AxiosResponse<any>> {
    return await new HTTPRequestBuilder(HTTPMethods.POST, `${this.resourcePath}/`)
      .setData(item)
      .build()
      .execute()
  }
}
